import LegalPageLayout from '../../components/legal/LegalPageLayout'

export default function GraffitiOSPrivacyPage() {
  return (
    <LegalPageLayout
      title="Graffiti™ OS Privacy Policy"
      subtitle="Product supplement to the SynthetIQ Signals® Privacy Policy"
      effectiveDate="To be set upon legal review — not yet in effect"
      lastUpdated="2026-09-25 (draft)"
      bannerText="Placeholder — pending legal team review. This page has not been reviewed or approved by legal counsel and should not be relied on as final."
      backTo="/corporate/legal/privacy"
      backLabel="Back to Privacy Policy"
      intro={[
        'This Graffiti™ OS Privacy Policy ("Product Privacy Policy") governs how SynthetIQ Signals®, Inc. collects, uses, and stores personal data when you use the Graffiti™ OS platform, including its web application, API services, and associated integrations (collectively, the "Platform"). Graffiti™ OS runs on the 23Controls™ control layer, both operated by SynthetIQ Signals®, Inc. under license from Mimeograph Holdings, LLC.',
        'This policy supplements our main Privacy Policy and adds detail specific to the Platform. Please read both to understand our practices.',
      ]}
      sections={[
        {
          heading: '1. What We Collect and Why',
          list: [
            'Account and authentication: name, email, encrypted password, SSO credentials, organization and role, device/browser information — to create and secure your account and authenticate you.',
            'Platform usage and content: files, documents, configurations, queries, outputs, and project metadata you submit or generate — to provide Platform functionality, storage, and collaboration.',
            'AI and machine learning processing: content submitted for AI features, prompts, and feedback on AI outputs — to generate outputs and improve accuracy. Input data is processed in real time; identifiable content is not used to train models for other users without your explicit consent.',
            'API access: API keys, request logs, and integration configuration — to authenticate and monitor API usage and support developers.',
            'Payment and subscription: billing contact information, payment method metadata (via Stripe — full card numbers are not stored on our systems), invoice and subscription history.',
            'Support and communications: support ticket content, email and chat communications, and feedback.',
          ],
        },
        {
          heading: '2. How We Protect Your Data',
          list: [
            'Encryption in transit and at rest.',
            'Role-based access controls and multi-factor authentication.',
            'Regular security audits and monitoring on our cloud infrastructure.',
          ],
        },
        {
          heading: '3. Data Retention',
          table: {
            headers: ['Data Type', 'Retention Period'],
            rows: [
              ['Account information', 'Duration of account, plus a short window after closure'],
              ['User-generated content', 'Duration of account, plus a short window after closure'],
              ['API request logs', 'Limited retention window for troubleshooting and abuse detection'],
              ['Payment records', '7 years (legal requirement)'],
              ['Support tickets', 'Several years after resolution'],
            ],
          },
          note: 'These windows are the standard categories from the original draft, not independently re-verified against this Platform\'s actual configured retention settings in this pass — confirm the exact day-counts before publishing.',
        },
        {
          heading: '4. How We Share Your Data',
          list: [
            'Cloud infrastructure and hosting providers (encrypted Platform data).',
            'Payment processing (Stripe) for subscription billing.',
            'AI service providers for AI-feature processing, under data-processing agreements; we do not allow third-party AI providers to use your data to train their general models.',
            'If you use the Platform through an organizational account, your organization administrators may have access to usage data and content, and may configure retention and access policies for their account.',
          ],
        },
        {
          heading: '5. Your Rights and Choices',
          list: [
            'View, export, correct, or delete your data through your account dashboard.',
            'Opt out of optional AI-powered features and control analytics participation.',
            'Manage email preferences, integrations, and API keys.',
            'Contact privacy@synthetiq.io for any privacy request not available through self-service — please include "Privacy Request – Graffiti™ OS" in the subject line.',
          ],
        },
        {
          heading: '6. Use by Children',
          paragraphs: [
            'The Platform is not intended for individuals under age 16. If you are under 18, you must have permission from a parent or legal guardian to use it.',
          ],
        },
        {
          heading: '7. Third-Party Integrations and AI Providers',
          paragraphs: [
            'When you connect third-party services to the Platform, we share only the data necessary for that integration, and you can review or revoke access at any time. Some AI features may route inputs through third-party AI providers under a data-processing agreement; you can opt out of features that use third-party AI services.',
          ],
        },
        {
          heading: '8. Contact Us',
          paragraphs: [
            'SynthetIQ Signals®, Inc. — Attn: Privacy Office, Graffiti™ OS',
            'Email: privacy@synthetiq.io',
          ],
        },
        {
          heading: '9. Policy Updates',
          paragraphs: [
            'We may update this policy to reflect changes in Platform features, data practices, or legal requirements, and will provide notice of material changes through the Platform or by email.',
          ],
        },
      ]}
    />
  )
}
